
import { defineStore, skipHydrate } from 'pinia'
import { getStorageSync, setStorageSync, removeStorageSync } from '@/utils/storage.js'

export type User = {
    ulid: string;
    name: string;
    email: string;
    avatar: string;
    must_verify_email: boolean;
    has_password: boolean;
    roles: string[];
    providers: string[];
}

export interface LoginInfo {
    accessToken: string;
    loginStatus: number;
    realName: string;
    companyId: number;
    companyName: string;
    phoneNumber: any;
    openid: any;
    userNo: string;
    companyCode: string;
    userId: number;
    user: User;
    companyType: number;
    admin: any;
    availableSign: number;
    contractSign: any;
    valetSign: any;
    gray: number;
    booleanGray: boolean;
    message: any;
    manufacturerNanage: boolean;
    openPreTaxAmount: any;
    modifyPrice: any;
    exceedSign: number;
    examineSign: number;
    materialSign: number;
    purchaseSign: number;
    investmentRank: any;
    phoneSign: number;
    negativeGrossProfit: any;
    supplierCode: any;
    tokenMdlList: any;
    roleType: number;
    subUserName: any;
    subTelephone: any;
    subRealName: any;
    subNote: any;
    companyList: any[];
    portraitPowerList: any;
    loginLockedTime: any;
    lockedType: any;
    errorTimes: any;
}

export const useUserStore = defineStore('user', () => {
    const loginInfo = ref<LoginInfo | null>(null)

    // Initialize from localStorage on client
    if (import.meta.client) {
        try {
            const stored = getStorageSync<LoginInfo>('user_info')
            if (stored) loginInfo.value = stored as LoginInfo
        } catch (e) {
            console.error('Failed to parse user_info', e)
        }
    }

    // Sync to localStorage
    watch(loginInfo, (newVal) => {
        if (import.meta.client) {
            if (newVal) {
                setStorageSync('user_info', newVal)
            } else {
                removeStorageSync('user_info')
            }
        }
    }, { deep: true })

    function setLoginInfo(info: LoginInfo) {
        loginInfo.value = info
    }

    function clearLoginInfo() {
        loginInfo.value = null
    }

    return {
        loginInfo: skipHydrate(loginInfo),
        setLoginInfo,
        clearLoginInfo
    }
})
